export const secondsToString = seconds => {
  if (!seconds) {
    return '00:00:00'
  }

  return new Date(0, 0, 0, 0, 0, seconds).toTimeString().split(' ')[0]
}
